import type { ProductDto, ProductListItemDto } from '@repo/api/web/models'
import type { Ref } from 'vue'

/**
 * 301-редирект «неправильного» слага PDP на канонический.
 * Товар резолвится по хвостовому id, поэтому /product/{любой-текст}-{id}
 * открывает ту же карточку — дубль-контент для поисковика. Сравниваем слаг
 * из URL с авторитетным (translit(Name)-id из ProductsRoutingService) и на
 * несовпадении отдаём постоянный редирект (на сервере — HTTP 301).
 */
export const useProductSlugRedirect = async (
  product: Ref<ProductDto | null | undefined>,
) => {
  if (!product.value) return

  const route = useRoute()
  const { routing } = useProducts()

  const listItem = product.value as unknown as ProductListItemDto
  if (route.params.id === routing.getProductSlug(listItem)) return

  await navigateTo(
    routing.getDetails(listItem, route.query.category as string | undefined)
      .route,
    { redirectCode: 301, replace: true },
  )
}
